import { render } from "./DocumentacionDetallada.vue?vue&type=template&id=66e20fc4&scoped=true"
import script from "./DocumentacionDetallada.vue?vue&type=script&lang=js"
export * from "./DocumentacionDetallada.vue?vue&type=script&lang=js"

import "./DocumentacionDetallada.vue?vue&type=style&index=0&id=66e20fc4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e20fc4"]])

export default __exports__